export interface TransactionTabState {
    tabs: Record<string, number>;
}

export const initialTransactionTabState: TransactionTabState = { tabs: {} };
